import React, { useState } from 'react';
import './App.css';
import Loader from './components/Loader/Loader';
import StartPage from './components/StartPage/StartPage';
import NavbarGame from './components/NavbarGame/NavbarGame';
import InfoPage from './components/InfoPage/InfoPage';
import GamePage from './components/GamePage/GamePage';
import ShowPage from './components/GamePage/ShowPage';
import FinishGame from './components/FinishGame/FinishGame';
import textContents from './data/dataInterface';
import InfoCity from './components/InfoPage/InfoCity';

let imagesName = {};
let imagesArr = {};     //массив с картинками, ключ - название картинки
let rightPlace = [];    //место положение правильного ответа
let wrongNameId = [];
let langv = 'rus';
let isLoad = false;
let num = 0;

function rightWrongPlace() {  //делаем случайным положение правильного ответа
    rightPlace = [];

    for (let i = 0; i < imagesName.length; i++) {
        rightPlace.push(Math.floor(Math.random() * 2));
    }

    shuffle(imagesName);  //перемешиваем массив слов-картинок, в этом порядке будет идти текущая игра
    shuffle(wrongNameId);
    for (let i = 0; i < imagesName.length; i++) {
        if (imagesName[i] === wrongNameId[i]) {
            let a = wrongNameId[i];
            if (i === imagesName.length - 1) {
                wrongNameId[i] = wrongNameId[i - 1];
                wrongNameId[i - 1] = a;
            } else {
                wrongNameId[i] = wrongNameId[i + 1];
                wrongNameId[i + 1] = a;
            }
        }
    }
};

function GameContent(content, callback) { 
    imagesName = Object.keys(content);
    wrongNameId = Object.keys(content);
  
   for(let id of imagesName) {                 //чтение в кэш картинок контента, ключ - название картинки
        
        let urlFile = process.env.PUBLIC_URL +'/content/' + id + '.png';
        imagesArr[id] = new Image(250,220);
       imagesArr[id].src = urlFile;
/*
       urlFile = process.env.PUBLIC_URL + '/content/' + id + '.jpg';
       imagesArr[id + '-1'] = new Image(360, 200);
       imagesArr[id + '-1'].src = urlFile;*/

       urlFile = process.env.PUBLIC_URL + '/content/' + id + '-2.jpg';
       imagesArr[id + '-2'] = new Image(540, 300);
       imagesArr[id + '-2'].src = urlFile;

    };
    let backgroundsName = ["bgStartRus", "bgStartFin", "bgInfo", "bgGame", "bgFinishFin", "bgFinishRus"];
    for (let id of backgroundsName) {
        imagesArr[id] = new Image(700, 650);
        imagesArr[id].src = process.env.PUBLIC_URL + '/interface/' + id + '.jpg';
    }
    rightWrongPlace();
  
    callback();
};

function readData() { //чтение данных 
    let address = window.top.document.location.href; //определение языка на котором находится игра
    if (address.indexOf('/fin/') > 0) langv = 'fin';
   
    GameContent(textContents.content, function() { isLoad = true; });
 };

readData();

//Функции перемешивания масива

//вспомогательная функция
function putToCache(elem, cache){
	if(cache.indexOf(elem) !== -1){
		return;
	}
	var i = Math.floor(Math.random()*(cache.length + 1));
	cache.splice(i, 0, elem);
}
//функция, возвращающая свеженький, девственный компаратор
function madness(){
	var cache = [];
	return function(a, b){
		putToCache(a, cache);
		putToCache(b, cache);
		return cache.indexOf(b) - cache.indexOf(a);
	}; 
}
//собственно функция перемешивания
function shuffle(arr){
	var compare = madness();
	return arr.sort(compare);
};

  
export default function App() {
    const [isLoading, setIsLoading] = useState(false);  //окно1, признак загрузки контента
    const [isStart, setIsStart] = useState(false);      //окно2, начало игры с нуля, выбор языка
    const [isInfo, setIsInfo] = useState(false);        //окно3, инструкция к игре
    const [isNavbar, setIsNavbar] = useState(false);	//окно4, верхнее меню

    const [isGame, setIsGame] = useState(false);		//окно5, игра первая страница
    const [isShow, setIsShow] = useState(false);		//окно7, просмотр сделанного 
    const [isCity, setIsCity] = useState(false);		//окно6, игра вторая страница
    const [isFinish, setIsFinish] = useState(false);	//окно8, конец игры

    const [lang, setLang] = useState(langv);
    const [step, setStep] = useState(0);
  
    const [okStep, setOkStep] = useState(-1);            //номер последнего сделанного вопроса
    const [imgId, setImgId] = useState(1);
    const [wrongId, setWrongId] = useState(1);
 
    const preloadTime = (() => {

        for (let i = 0; i < 4; i++) {
            if (num > 0) break;
            if (isLoad && num === 0) {
                setIsLoading(isLoad);
                setImgId(imagesName[0]);
                setWrongId(wrongNameId[0]);
                setIsStart(true);
                setStep(0);
                num++;
                break;
            }
            setTimeout(setIsLoading, 2000, isLoad);
        }
    });

    setTimeout(preloadTime, 3000);
   
    const handleComponent = ((pri, place, id) => {
        if (pri === 'rus' && lang === 'fin') {
            setLang('rus');
            langv = lang;
        };
        if (pri === 'fin' && lang === 'rus') {
            setLang('fin');
            langv = lang;
        };
        if (pri === 'start') {
            setIsStart(false);
            setIsInfo(true);
            setIsNavbar(true);
            setStep(0);
            setOkStep(-1);
        };

        if (pri === 'continue') {
            setIsInfo(false);
            if (okStep > step) setIsShow(true);
            else {
       
                setIsGame(true);
            }
        };
        
        if (pri === 'info') {
            setIsInfo(true);
            setIsGame(false);
            setIsShow(false);
            setIsCity(false);
        };
        if (pri === 'toStart') {
            rightWrongPlace()
            setIsStart(true);
            setIsGame(false);
            setIsShow(false);
            setIsInfo(false);
            setIsNavbar(false);
            setIsFinish(false);
             setImgId(imagesName[0]);
            setWrongId(wrongNameId[0]);
            setStep(0);
        }

        if (pri === 'wrong') {
          
        };

        if (pri === 'answer') {
            setOkStep(step);
            setTimeout(() => {
            setIsGame(false);
            setIsCity(true);
        }, 4000);
        };
      if (pri === 'ShowNext') {
          setIsShow(false);
          setIsCity(true);
        };

        if (pri === 'prev') {
            if (isCity) {
                setIsCity(false);
                setIsShow(true);
            }
            if (isGame || isShow) {
                setIsShow(false);
                setIsGame(false);
                setStep(step - 1);
                setImgId(imagesName[step - 1]);
                setIsCity(true);
            }
            if (isFinish) {
                setIsFinish(false);
                setIsCity(true);
            }
        }; 
        if (pri === 'next') {
                setIsCity(false);
                if (step >= (imagesName.length - 1)) {
                    setIsFinish(true);
                }
                else {
                    setStep(step + 1);
                    setImgId(imagesName[step + 1]);
                    if (okStep === (step)) {
                        setWrongId(wrongNameId[step + 1]);
                        setIsGame(true);
                    }
                    else {
                        setIsShow(true);
                    }
                }
        } 
    });

  return (
    <div className='App'>
          {!isLoading ? <Loader /> : null}
          {isNavbar ? <NavbarGame lang={lang} onClick={(pri) => handleComponent(pri)} topMenu={textContents.topMenu} /> : null}
          {isInfo ? <InfoPage lang={lang} onClick={(pri) => handleComponent(pri)} textGame={textContents.textGame} src={imagesArr['bgInfo'].src} /> : null}

          {isGame ? <GamePage step={step} lang={lang} 
              answer={textContents.content[imgId][lang].name}
              wrong={textContents.content[wrongId][lang].name}
              task={textContents.textGame.Task[lang]}
              link={textContents.content[imgId].address}
              imgId={imgId}  src={imagesArr[imgId].src} srcImg={imagesArr[imgId+'-2'].src} bgSrc={imagesArr['bgGame'].src}
              rightButton={rightPlace[step]} onClick={(pri) => handleComponent(pri)} /> : null}

          {isCity ? <InfoCity lang={lang} onClick={(pri) => handleComponent(pri)} text={textContents.content[imgId][lang]} src={imagesArr[imgId].src} bgSrc={imagesArr['bgInfo'].src} textGame={textContents.textGame}/> : null}

          {isShow ? <ShowPage lang={lang} onClick={(pri) => handleComponent(pri)} src={imagesArr[imgId].src} srcImg={imagesArr[imgId + '-2'].src} bgSrc={imagesArr['bgGame'].src} text={textContents.content[imgId]} /> : null}

          {isStart ? (<StartPage lang={lang} onClick={(pri) => handleComponent(pri)} startPage={textContents.startPage} src={(lang === 'rus') ? imagesArr['bgStartRus'].src : imagesArr['bgStartFin'].src} />) : null}
          {isFinish ? <FinishGame lang={lang} onClick={(pri) => handleComponent(pri)} src={(lang === 'rus') ? imagesArr['bgFinishRus'].src : imagesArr['bgFinishFin'].src} /> : null}

      
    </div>
  );
};
